import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { blogPostsData } from '../../mocks/blog';
import { useState } from 'react';

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('All');

  useEffect(() => {
    document.title = 'Tax Insights & Blog | Bold Plans Advisory Jacksonville FL';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Read expert tax strategies, IRS updates, and financial planning insights from Bold Plans Advisory in Jacksonville, Florida. Stay informed on tax preparation and planning.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`);

    const scriptId = 'schema-blog';
    document.getElementById(scriptId)?.remove();
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Blog",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`,
      "name": "Tax Insights & Updates | Bold Plans Advisory",
      "description": "Expert tax strategies, IRS regulatory updates, and financial planning insights from Bold Plans Advisory in Jacksonville, Florida.",
      "publisher": {
        "@type": "LocalBusiness",
        "name": "Bold Plans Advisory",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Jacksonville",
          "addressRegion": "FL",
          "addressCountry": "US"
        }
      }
    });
    document.head.appendChild(script);
    return () => { document.getElementById(scriptId)?.remove(); };
  }, []);

  const categories = ['All', 'Business Tax', 'Tax Planning', 'Tax Compliance'];

  const filteredPosts = selectedCategory === 'All'
    ? blogPostsData
    : blogPostsData.filter(post => post.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <section className="py-24 bg-cream-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <p className="text-orange-500 text-sm font-sans font-semibold tracking-wider mb-4">
              /INDUSTRY INSIGHTS
            </p>
            <h1 className="font-montserrat font-bold text-6xl text-gray-900 mb-6">Tax Insights & Updates</h1>
            <p className="text-xl text-gray-600 font-sans max-w-3xl mx-auto">
              Stay informed with expert tax strategies, regulatory updates, and financial planning insights
            </p>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-wrap gap-3 justify-center mb-12">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 rounded-full font-sans font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-orange-500 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <Link
                  key={post.id}
                  to={`/blog/${post.slug}`}
                  className="group bg-white rounded-3xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    {post.aiGenerated && (
                      <div className="absolute top-4 right-4 bg-purple-600 text-white px-3 py-1 rounded-full text-xs font-sans font-semibold flex items-center gap-1">
                        <i className="ri-sparkling-line"></i>
                        AI-Enhanced
                      </div>
                    )}
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-xs font-sans font-semibold">
                        {post.category}
                      </span>
                      <span className="text-gray-500 text-xs font-sans">{post.readTime}</span>
                    </div>
                    <h3 className="font-montserrat font-bold text-xl text-gray-900 mb-3 line-clamp-2 group-hover:text-orange-500 transition-colors">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 font-sans text-sm leading-relaxed line-clamp-3 mb-4">
                      {post.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-gray-500 text-xs font-sans">{post.date}</span>
                      <div className="flex items-center gap-2 text-orange-500 font-sans font-semibold text-sm group-hover:gap-3 transition-all">
                        Read More
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;